import React, { useState, useEffect, useContext } from 'react'
import { AuthContextApi } from '../../Context/api'
import { toast } from 'react-toastify'
import {
    ChartBarIcon,
    UsersIcon,
    DocumentTextIcon,
    BoltIcon,
    UserGroupIcon,
    CalendarIcon,
} from '@heroicons/react/24/outline'
import { jsonConfig } from '../../Config'
import './styles.css'
import CardMetricas from '../../Components/Cards/Metricas'
import CardActions from '../../Components/Cards/Actions'

const Dashboard = () => {
    const { checkLogin, getDashBoardataSistema } = useContext(AuthContextApi)

    // Verificar permissão do usuário
    const userPermission = localStorage.getItem('permisssion')
    const isAdmin = true
    const isGerente = userPermission === jsonConfig.roles.gerente
    const isOperacional = userPermission === jsonConfig.roles.operacional

    // Estados locais

    // Estado para dados do dashboard
    const [dashboardStats, setDashboardStats] = useState([])


    const cardActions = [
        {
            id: 1,
            title: 'Contas de Recebimento',
            description: 'Gerenciar contas de recebimento do sistema',
            icon: CalendarIcon,
            color: 'orange',
            href: '/contasRecebimento'
        }, {
            id: 2,
            title: 'Clientes',
            description: 'Gerenciar clientes do sistema',
            icon: UserGroupIcon,
            color: 'green',
            href: '/clientes'
        }, {
            id: 3,
            title: 'Serviços',
            description: 'Gerenciar serviços do sistema',
            icon: BoltIcon,
            color: 'blue',
            href: '/servicos'
        },
        {
            id: 4,
            title: 'Faturas',
            description: 'Gerenciar faturas do sistema',
            icon: DocumentTextIcon,
            color: 'purple',
            href: '/faturas'
        }
    ]


    // Função para carregar dados do dashboard (apenas para admin)
    const loadDashboardData = async () => {
        if (!isAdmin) {
            return // Não carregar dados para não-admin
        }
        try {
            const response = await getDashBoardataSistema()
            if (response && response.status) {
                setDashboardStats(response.data)
                toast.success('Dashboard carregado com sucesso!')
            }
        } catch (error) {
            console.error('Erro ao carregar dados do dashboard:', error)
            toast.error('Erro ao carregar dados do dashboard')
        }
    }

    // useEffect para carregar dados iniciais
    useEffect(() => {
        checkLogin()
        loadDashboardData()
    }, [])

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4 overflow-x-hidden max-w-full">
            <div className="max-w-full w-full">
                {/* Header */}
                <div className="mb-8 max-w-full">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 gap-4 max-w-full">
                        <div className="flex items-center space-x-4 flex-shrink-0 min-w-0">
                            <div className="p-3 bg-gradient-to-r from-brand-dark to-brand-cyan rounded-2xl shadow-lg flex-shrink-0">
                                <ChartBarIcon className="w-8 h-8 text-white" />
                            </div>
                            <div className="min-w-0">
                                <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-brand-dark to-brand-cyan bg-clip-text text-transparent truncate">
                                    Dashboard
                                </h1>
                                <p className="text-sm sm:text-base text-gray-600 truncate">Visão geral do sistema Experts Control</p>
                            </div>
                        </div>
                        <div className="flex items-center space-x-3 flex-shrink-0">
                            <div className="text-right">
                                <p className="text-xs sm:text-sm text-gray-600">Bem-vindo de volta,</p>
                                <p className="font-semibold text-sm sm:text-base text-gray-900 truncate max-w-[150px] sm:max-w-none">
                                    {localStorage.getItem('usuario') || 'Usuário'}
                                </p>
                            </div>
                            <div className="w-10 h-10 bg-gradient-to-r from-brand-dark to-brand-cyan rounded-full flex items-center justify-center flex-shrink-0">
                                <UsersIcon className="w-5 h-5 text-white" />
                            </div>
                        </div>
                    </div>

                    {/* Dashboard Cards - Apenas para Admin */}
                    {isAdmin && (
                        <div className="max-w-full overflow-x-hidden">
                            <CardMetricas dataMetricas={dashboardStats} />
                        </div>
                    )}
                </div>

                {/* Quick Actions */}
                <div className="max-w-full overflow-x-hidden">
                    <CardActions actions={cardActions} />
                </div>
            </div>
        </div>
    )
}

export default Dashboard